module.exports = __webpack_public_path__ + "static/media/fahlgrens.52bed2fa.jpg";